import { render, staticRenderFns } from "./CompletedOrder.vue?vue&type=template&id=02194918&scoped=true&"
import script from "./CompletedOrder.vue?vue&type=script&lang=js&"
export * from "./CompletedOrder.vue?vue&type=script&lang=js&"
import style0 from "./CompletedOrder.vue?vue&type=style&index=0&id=02194918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02194918",
  null
  
)

export default component.exports